import { lf } from '@/api/data/lovefield';
const { STRING, NUMBER, STRING_ARRAY } = lf.Type;
export const EdmContactSearch = {
    name: 'edm_contact_search',
    using: 'loki',
    global: true,
    version: 1,
    cache: false,
    tables: [
        {
            name: 'contact',
            columns: [
                {
                    name: 'id',
                    type: STRING,
                },
                {
                    name: 'orgId',
                    type: STRING,
                },
                {
                    name: 'company',
                    type: STRING,
                },
                {
                    name: 'contactName',
                    type: STRING,
                },
                {
                    name: 'contactPYName',
                    type: STRING,
                },
                {
                    name: 'contactPYLabelName',
                    type: STRING,
                },
                {
                    name: 'accountName',
                    type: STRING,
                },
                {
                    name: 'managerList',
                    type: STRING_ARRAY,
                },
                {
                    name: 'type',
                    type: STRING,
                },
                {
                    name: '_lastUpdateTime',
                    type: NUMBER,
                },
                {
                    name: '_company',
                    type: STRING,
                },
            ],
            primaryKey: {
                columns: [],
            },
            index: [
                {
                    columns: ['_company', 'orgId', '_lastUpdateTime'],
                },
                {
                    columns: ['id'],
                },
            ],
        },
        {
            name: 'org',
            columns: [
                {
                    name: 'id',
                    type: STRING,
                },
                {
                    name: 'orgName',
                    type: STRING,
                },
                {
                    name: 'orgPYName',
                    type: STRING,
                },
                {
                    name: 'type',
                    type: NUMBER,
                },
                {
                    name: 'orgRank',
                    type: NUMBER,
                },
                {
                    name: '_company',
                    type: STRING,
                },
                {
                    name: 'managerList',
                    type: STRING_ARRAY,
                },
                {
                    name: '_lastUpdateTime',
                    type: NUMBER,
                },
            ],
            primaryKey: {
                columns: [],
            },
            index: [
                {
                    columns: ['_company', '_lastUpdateTime'],
                },
                {
                    columns: ['id'],
                },
            ],
        },
    ],
};
export const ContactSearchDB = {
    name: 'contact_search',
    using: 'loki',
    global: false,
    version: 6,
    cache: false,
    tables: [
        {
            name: 'contact',
            columns: [
                {
                    name: '_lokiKey',
                    type: STRING,
                },
                {
                    name: 'id',
                    type: STRING,
                },
                {
                    name: 'emails',
                    type: STRING_ARRAY,
                },
                {
                    name: 'contactName',
                    type: STRING,
                },
                {
                    name: 'contactPYName',
                    type: STRING,
                },
                {
                    name: 'contactPYLabelName',
                    type: STRING,
                },
                {
                    name: 'accountName',
                    type: STRING,
                },
                {
                    name: 'avatar',
                    type: STRING,
                },
                {
                    name: 'avatarPendant',
                    type: STRING,
                },
                {
                    name: 'visibleCode',
                    type: NUMBER,
                },
                {
                    name: 'position',
                    type: STRING,
                },
                {
                    name: 'type',
                    type: STRING,
                },
                {
                    name: 'enterpriseId',
                    type: STRING,
                },
                {
                    name: 'info',
                    type: STRING,
                },
                {
                    name: '_lastUpdateTime',
                    type: NUMBER,
                },
            ],
            primaryKey: {
                columns: ['_lokiKey'],
            },
            index: [
                {
                    columns: ['id'],
                },
                {
                    columns: ['accountName'],
                },
            ],
        },
        {
            name: 'org',
            columns: [
                {
                    name: 'id',
                    type: STRING,
                },
                {
                    name: 'originId',
                    type: STRING,
                },
                {
                    name: 'orgName',
                    type: STRING,
                },
                {
                    name: 'orgPYName',
                    type: STRING,
                },
                {
                    name: 'type',
                    type: NUMBER,
                },
                {
                    name: 'orgRank',
                    type: NUMBER,
                },
                {
                    name: 'visibleCode',
                    type: STRING,
                },
                {
                    name: 'memberNum',
                    type: NUMBER,
                },
                {
                    name: 'enterpriseId',
                    type: NUMBER,
                },
                {
                    name: 'parent',
                    type: STRING,
                },
                {
                    name: 'level',
                    type: NUMBER,
                },
                {
                    name: 'childrenCount',
                    type: NUMBER,
                },
                {
                    name: 'marked',
                    type: NUMBER,
                },
                {
                    name: 'source',
                    type: STRING,
                },
                {
                    name: '_lastUpdateTime',
                    type: NUMBER,
                },
            ],
            primaryKey: {
                columns: ['id'],
            },
            index: [
                {
                    columns: ['id'],
                },
                {
                    columns: ['enterpriseId'],
                },
            ],
        },
        {
            name: 'orgpathlist',
            columns: [
                {
                    name: 'id',
                    type: STRING,
                },
                {
                    name: 'pathIdList',
                    type: STRING_ARRAY,
                },
                {
                    name: 'pathNameList',
                    type: STRING_ARRAY,
                },
                {
                    name: 'enterpriseId',
                    type: NUMBER,
                },
            ],
            primaryKey: {
                columns: ['id'],
            },
            index: [
                {
                    columns: ['id'],
                },
                {
                    columns: ['enterpriseId'],
                },
            ],
        },
        {
            name: 'orgContact',
            columns: [
                {
                    name: 'id',
                    type: STRING,
                },
                {
                    name: 'contactId',
                    type: STRING,
                },
                {
                    name: 'orgId',
                    type: STRING,
                },
                {
                    name: 'type',
                    type: STRING,
                },
                {
                    name: 'enterpriseId',
                    type: NUMBER,
                },
                {
                    name: 'rankNum',
                    type: NUMBER,
                },
            ],
            primaryKey: {
                columns: ['id'],
            },
            index: [
                {
                    columns: ['id'],
                },
                {
                    columns: ['orgId'],
                },
            ],
        },
        {
            name: 'personal_mark',
            columns: [
                {
                    name: 'id',
                    type: STRING,
                },
                {
                    name: 'type',
                    type: NUMBER,
                },
                {
                    name: 'value',
                    type: STRING,
                },
                {
                    name: 'name',
                    type: STRING,
                },
                {
                    name: 'emails',
                    type: STRING_ARRAY,
                },
                {
                    name: 'originId',
                    type: STRING,
                },
                {
                    name: 'unreadMailCount',
                    type: STRING,
                },
                {
                    name: 'marked',
                    type: NUMBER,
                },
            ],
            primaryKey: {
                columns: ['id'],
            },
            index: [
                {
                    columns: ['type'],
                },
                {
                    columns: ['value'],
                },
            ],
        },
        {
            name: 'lx_info',
            columns: [
                {
                    name: 'contactId',
                    type: STRING,
                },
                {
                    name: 'avatar',
                    type: STRING,
                },
                {
                    name: 'yxid',
                    type: STRING,
                },
                {
                    name: 'yxToken',
                    type: STRING,
                },
            ],
            primaryKey: {
                columns: ['contactId'],
            },
            index: [
                {
                    columns: ['contactId'],
                },
            ],
        },
    ],
};
